export const isOverflownVertically = (parent: Element, target: Element) => {
  const { top, bottom } = parent.getBoundingClientRect();
  const { top: targetTop, bottom: targetBottom } =
    target.getBoundingClientRect();

  return targetBottom > bottom || targetTop < top;
};
